import { render, staticRenderFns } from "./ResultRiskManage.vue?vue&type=template&id=6bcf06d8&scoped=true&"
import script from "./ResultRiskManage.vue?vue&type=script&lang=js&"
export * from "./ResultRiskManage.vue?vue&type=script&lang=js&"
import style0 from "./ResultRiskManage.vue?vue&type=style&index=0&id=6bcf06d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcf06d8",
  null
  
)

export default component.exports